/**
 * Per-day hours for a class that meets at different times on different
 * days, e.g. Monday 5 PM and Saturday 9 AM.
 *
 * One row per weekday the class dates fall on. A day without its own time
 * shows, and keeps, the class's main start and end time; only days that
 * differ are saved (see utils/classDayTimes).
 */
import React from "react";
import TimePicker12Hour from "../ui/TimePicker12Hour";

const capitalize = (day) => day.charAt(0).toUpperCase() + day.slice(1);

export default function ClassDayTimes({
  weekdays,
  enabled,
  dayTimes,
  defaultStart,
  defaultEnd,
  errors,
  onToggle,
  onChange,
}) {
  return (
    <div className="space-y-3">
      <label className="flex items-center gap-2 text-sm font-manrope text-heading-dark">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onToggle(e.target.checked)}
        />
        Different times on different days
      </label>

      {enabled && weekdays.length === 0 && (
        <p className="text-xs text-gray-600">
          Pick the class dates first, then set a time for each day.
        </p>
      )}

      {enabled &&
        weekdays.map((day) => {
          const own = dayTimes?.[day] || {};
          const label = capitalize(day);
          const error = errors?.[`day_time_${day}`];
          return (
            <div key={day}>
              <div className="grid sm:grid-cols-[120px_1fr_1fr] grid-cols-1 gap-3 items-center">
                <span className="text-sm font-medium font-manrope text-heading-dark">
                  {label}
                </span>
                <TimePicker12Hour
                  value={own.start_time || defaultStart}
                  onChange={(value) => onChange(day, "start_time", value)}
                  placeholder={`${label} start time`}
                />
                <TimePicker12Hour
                  value={own.end_time || defaultEnd}
                  onChange={(value) => onChange(day, "end_time", value)}
                  placeholder={`${label} end time`}
                />
              </div>
              {error && <p className="text-btn-gold text-sm mt-1">{error}</p>}
            </div>
          );
        })}
    </div>
  );
}
